import { Box, Button, Heading, Modal } from '@zillow/constellation-10';
import AttachmentGuidelinesBody from './AttachmentGuidelinesBody';

type AttachmentGuidelinesProps = {
  onClose(): void;
};

export default function AttachmentGuidelines({ onClose }: AttachmentGuidelinesProps) {
  return (
    <Modal
      dividers={false}
      open={true}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      size={{ base: 'fullScreen', md: 'md' }}
      header={
        <Heading level={2} textStyle="heading-xs">
          Attachment guidelines
        </Heading>
      }
      body={
        <Box css={{ padding: 'default' }}>
          <AttachmentGuidelinesBody variant="default" />
        </Box>
      }
      footer={
        <Button emphasis="filled" onClick={onClose} tone="brand" data-testid="close-button">
          Close
        </Button>
      }
    />
  );
}
